/**
 * Builds a document code in the Tunielec format: PREFIX-YYYY-NNNN
 *
 * Backed by the per-tenant atomic sequence (RPC get_next_sequence_value
 * already used by sales/purchases). The seqName is namespaced to keep
 * pro counters distinct from ERP counters.
 */
export function formatProDocCode(
  prefix: 'DEV' | 'CMD',
  year: number,
  sequenceValue: number,
): string {
  return `${prefix}-${year}-${String(sequenceValue).padStart(4, '0')}`;
}

export const PRO_DEVIS_SEQ = 'pro_devis';
export const PRO_COMMANDE_SEQ = 'pro_commande';
